// extracted by mini-css-extract-plugin
export default {"poppins":"Style_poppins__YPSbJ","times_new_roman":"Style_times_new_roman__aSmiO"};